// src/components/common/DynamicInput.jsx

export default function DynamicInput({ field, value, onChange }) {

    return (
        <div className="form-group mt-4">
            <label className="mb-1 text-dark fs-5">
                {field?.label}
                {field?.required && <sup className="text-danger">*</sup>}
            </label>

            <input
                type={field?.type === "password" ? "password" : "text"}
                className="form-control"
                name={field?.name}
                value={value || field?.defaultValue || ""}
                // onChange={(e) => onChange(field?.name, e?.target?.value)}
                onChange={(e) => !field.readonly && onChange(field.name, e.target.value)}
                readOnly={field.readonly === true}
                maxLength={field?.type === "mobile" ? 10 : undefined}
            />
        </div>
    );
}